import React, { useEffect, useRef } from "react";
import * as d3 from "d3";

const Visualization = ({ data }) => {
  const svgRef = useRef();

  useEffect(() => {
    const svg = d3.select(svgRef.current);
    svg.selectAll("*").remove(); // Wyczyszczenie poprzedniego renderu

    const width = 10000;
    const height = 10000;

    svg.attr("width", width).attr("height", height);

    // Tooltip
    const tooltip = d3
      .select("body")
      .append("div")
      .style("position", "absolute")
      .style("background", "#fff")
      .style("border", "1px solid #ccc")
      .style("border-radius", "5px")
      .style("padding", "10px")
      .style("box-shadow", "0px 2px 5px rgba(0,0,0,0.2)")
      .style("pointer-events", "none")
      .style("display", "none");

    // Renderowanie alejek poziomo
    data.shelfLines.forEach((line, lineIndex) => {
      const lineGroup = svg
        .append("g")
        .attr("transform", `translate(${lineIndex * 60 + 120}, 50)`); // Większy odstęp między alejkami

      // Etykieta alejki (numer alejki na górze)
      lineGroup
        .append("text")
        .attr("x", 5)
        .attr("y", -10)
        .text(`${line.id}`)
        .attr("font-size", "30px")
        .attr("font-weight", "bold")
        .attr("fill", "black");

      // Regały w alejce (orientacja pozioma)
      line.shelves.forEach((shelf, shelfIndex) => {
        const shelfGroup = lineGroup
          .append("g")
          .attr("transform", `translate(0, ${shelfIndex * 85})`); // Większy odstęp między regałami

        // Kolorowanie według zapełnienia
        const flatBoxUtilization = parseFloat(shelf.flatBox.utilization);
        const deepBoxUtilization = parseFloat(shelf.deepBox.utilization);

        const flatBoxColor =
          shelf.flatBox.maxCapacity === 0
            ? "grey"
            : flatBoxUtilization < 50
            ? "green"
            : flatBoxUtilization < 80
            ? "orange"
            : "red";

        const deepBoxColor =
          shelf.deepBox.maxCapacity === 0
            ? "grey"
            : deepBoxUtilization < 50
            ? "green"
            : deepBoxUtilization < 80
            ? "orange"
            : "red";

        // Dodanie gradientu
        const gradient = svg
          .append("defs")
          .append("linearGradient")
          .attr("id", `gradient-${line.id}-${shelf.number}`)
          .attr("x1", "0%")
          .attr("y1", "0%")
          .attr("x2", "0%")
          .attr("y2", "100%");
        gradient
          .append("stop")
          .attr("offset", "50%")
          .attr("stop-color", flatBoxColor);
        gradient
          .append("stop")
          .attr("offset", "50%")
          .attr("stop-color", deepBoxColor);

        // Prostokąt regału z gradientem
        shelfGroup
          .append("rect")
          .attr("width", 40)
          .attr("height", 80) // Łączna wysokość
          .attr("fill", () => {
            if (flatBoxColor === "grey" && deepBoxColor === "grey") return "grey";
            if (flatBoxColor === "grey") return deepBoxColor;
            if (deepBoxColor === "grey") return flatBoxColor;
            return `url(#gradient-${line.id}-${shelf.number})`; // Gradient
          })
          .attr("stroke", "black");

        // Tooltip dla regału
        shelfGroup
          .on("mouseover", (event) => {
            tooltip
              .style("display", "block")
              .html(
                `<strong>Regał ${shelf.number}</strong><br/>
                <strong>Flat Box:</strong><br/>
                ${
                  shelf.flatBox.maxCapacity === 0
                    ? "Brak miejsca"
                    : `- Maks: ${shelf.flatBox.maxCapacity}<br/>
                - Zapakowane: ${shelf.flatBox.stowed}<br/>
                - Zapełnienie: ${shelf.flatBox.utilization}%`
                }<br/>
                <strong>Deep Box:</strong><br/>
                ${
                  shelf.deepBox.maxCapacity === 0
                    ? "Brak miejsca"
                    : `- Maks: ${shelf.deepBox.maxCapacity}<br/>
                - Zapakowane: ${shelf.deepBox.stowed}<br/>
                - Zapełnienie: ${shelf.deepBox.utilization}%`
                }`
              )
              .style("left", `${event.pageX + 10}px`)
              .style("top", `${event.pageY + 10}px`);
          })
          .on("mousemove", (event) => {
            tooltip
              .style("left", `${event.pageX + 10}px`)
              .style("top", `${event.pageY + 10}px`);
          })
          .on("mouseout", () => {
            tooltip.style("display", "none");
          });

        // Numer regału (wyśrodkowany)
        shelfGroup
          .append("text")
          .attr("x", 20) // Środek prostokąta (poziomo)
          .attr("y", 45) // Środek prostokąta (pionowo)
          .attr("text-anchor", "middle") // Wyśrodkowanie tekstu w poziomie
          .attr("dominant-baseline", "middle") // Wyśrodkowanie tekstu w pionie
          .text(shelf.number)
          .attr("font-size", "12px")
          .attr("fill", "white");
      });
    });

    return () => {
      tooltip.remove(); // Usuwanie tooltipa przy demontażu komponentu
    };
  }, [data]);

  return <svg ref={svgRef}></svg>;
};

export default Visualization;
